import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notification-undo__plate" }
const _hoisted_2 = { class: "ndt-ring" }
const _hoisted_3 = { class: "ndt-ring__num" }
const _hoisted_4 = { class: "notification-undo__text" }

import {
	computed,
	onBeforeUnmount,
	onMounted,
	ref
} from "vue"

type Props = {
	text: string
	seconds?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationUndoOverlay',
  props: {
    text: {},
    seconds: { default: 5 }
  },
  emits: ["finish", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const countdown = ref(props.seconds)
let tickTimer: ReturnType<typeof setInterval> | null = null
let finishTimer: ReturnType<typeof setTimeout> | null = null
let finished = false

const rootStyle = computed(() => ({ '--ndt-duration': `${props.seconds}s` }))

const clearTimers = () => {
	if (tickTimer) {
		clearInterval(tickTimer)
		tickTimer = null
	}
	if (finishTimer) {
		clearTimeout(finishTimer)
		finishTimer = null
	}
}

const finish = () => {
	if (finished) {
		return
	}
	finished = true
	clearTimers()
	emit('finish')
}

onMounted(() => {
	tickTimer = setInterval(() => {
		countdown.value = Math.max(0, countdown.value - 1)
	}, 1000)
	finishTimer = setTimeout(finish, props.seconds * 1000)
})

onBeforeUnmount(clearTimers)

__expose({ flush: finish })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "notification-undo",
    style: _normalizeStyle(rootStyle.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          class: "ndt-ring__svg",
          viewBox: "0 0 20 20"
        }, [
          _createElementVNode("circle", {
            class: "ndt-ring__circle",
            cx: "10",
            cy: "10",
            r: "9"
          })
        ], -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(countdown.value), 1)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.text), 1),
      _createElementVNode("button", {
        type: "button",
        class: "notification-undo__cancel",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, _toDisplayString(_ctx.$t('ui_cancel')), 1)
    ])
  ], 4))
}
}

})